import store from 'dashboard/store';
import {
  accountUserHasPermission,
  getCurrentAccount,
} from 'dashboard/helper/permissionsHelper';

/**
 * Returns whether the current account user may perform `key` when a custom role is assigned.
 * Users without a custom role receive full access (backward compatibility).
 */
export function can(key) {
  const user = store.getters.getCurrentUser;
  const accountId = store.getters.getCurrentAccountId;

  // Custom role system must never restrict SuperAdmin/Administrator,
  // and must only activate for agents with a custom role.
  if (user?.type === 'SuperAdmin') return true;

  const currentAccount = getCurrentAccount(user, accountId) || {};
  if (currentAccount.role === 'administrator') return true;
  if (currentAccount.role !== 'agent') return true;
  if (!currentAccount.custom_role_id) return true;

  return accountUserHasPermission(user, accountId, key);
}

export function usePermissions() {
  return { can };
}
